export default __webpack_public_path__ + "static/media/Snd3.ae482f28.mp3";